export default __webpack_public_path__ + "static/media/btn_apply.73be2770.png";